import React from "react";
import loadable from "@loadable/component";
import NoticeIcon from "../../Icons/NoticeIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
const NoticeListComponent = loadable(
  () => import("../../components/Notices/NoticeList")
);
const NoticeList = () => {
  const { mutateAsync: PatchMutateasync, isLoading } = usePatchHook({
    queryKey: ["subject"],
  });
  const handleIsActive = async (value: any, id: string) => {
    const formData = {
      is_active: value,
    };
    const url = `${APIS.NOTICE}${id}/`;
    try {
      const res = await PatchMutateasync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <NoticeIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Notice</span>
      </div>
      <NoticeListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default NoticeList;
